<template>
  <div class="booking-form__review">
    <div id="quoteGen">
      <div class="header">
        <p>Booking Summary</p>
      </div>
      <div class="shipping-reference mt-3 mb-5">
        <p class="shipping-detail-title">
          <span>
            <img src="@/assets/images/booking-management/svgs/order-number.svg" alt="" />
          </span>
          SHIPPING REFERENCE
        </p>
        <p class="shipping-detail">
          {{
            shippingInformation.shippingReference
              ? shippingInformation.shippingReference
              : "N/A"
          }}
        </p>
      </div>
      <div class="container-fluid">
        <div class="row align-items-center justify-around">
          <div class="col-12 col-md-4 col-lg-4">
            <div
              class="d-flex my-auto text-light p-2 rounded"
              style="background: #10233e; min-height: 129px"
            >
              <div>
                <img
                  src="@/assets/images/icons/default-profile-image.svg"
                  alt="user image"
                  class="user-img img-fluid"
                />
              </div>
              <div class="shipper-details">
                <p>{{ shipper.contactName }}</p>
                <small>{{ shipper.email }}</small> <br />
                <small>{{ shipper.mobile }}</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4" >
            <div class="pickup-details p-2 rounded" style="background:#10233E; color:white; min-height:129px">
              <p class="shipping-detail-title text-light">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/location.svg"
                    alt="" /></span
                >PICK-UP LOCATION
              </p>
              <p class="shipping-detail text-light">
                {{
                  `${formatAddress(shipper.address)}
                 
                  ${shipper.city == null? '' : shipper.city}
                
                  ${shipper.country == null? '' : shipper.country}`
                }}
              </p>
            </div>
            
          </div>
          <div class="col-12 col-md-4 col-lg-4">
            <div class="p-2 rounded" style="background: #10233e; min-height: 129px">
              <p class="shipping-detail-title text-light">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/location.svg"
                    alt="" /></span
                >RECEIVER
              </p>
              <p class="shipping-detail text-light">{{ consignee.contactName }},</p>
              <p class="shipping-detail text-light">
                {{ consignee.address.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="container-fluid shipping-details">
        <div class="row">
          <div class="col-12">
            <p class="font-semibold">Shipment Details</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/port-of-origin.svg"
                  alt="" /></span
              >ORIGIN
            </p>
            <p class="shipping-detail">
              {{
                shippingInformation.shippingMethod == "drop-off"
                  ? takeOffObject.locationName
                  : "N/A"
              }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/specified-shipment.svg"
                  alt="" /></span
              >SPECIFIED SHIPMENT
            </p>
            <p class="shipping-detail">
              {{
                packageInformation[0].shipmentType
                  ? packageInformation[0].shipmentType
                  : "Package"
              }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/shipping-mode.svg"
                  alt="" /></span
              >SHIPPING MODE
            </p>
            <p class="shipping-detail">
              {{
                shippingInformation.shippingMethod
                  ? shippingInformation.shippingMethod
                  : "N/A"
              }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/package-type.svg"
                  alt="" /></span
              >PACKAGE TYPE
            </p>
            <p class="shipping-detail">
              {{ packagingType? packagingType :  'N/A'}}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/port-of-destination.svg"
                  alt="" /></span
              >DESTINATION
            </p>
            <p class="shipping-detail">
              {{
                shippingInformation.shippingMethod == "drop-off"
                  ? pickUpObject.locationName
                  : "N/A"
              }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/booking-channel.svg"
                  alt="" /></span
              >BOOKING CHANNEL
            </p>
            <p class="shipping-detail">MULEEX</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/shipping-option.svg"
                  alt="" /></span
              >SHIPPING OPTION
            </p>
            <p class="shipping-detail">
              {{
                paymentInformation.orgName ? paymentInformation.orgName : "Express (Air)"
              }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                  alt="" /></span
              >WAYBILL NO
            </p>
            <p class="shipping-detail">SC02099X</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                  alt="" /></span
              >PACKAGE DESCRIPTION
            </p>
            <p class="shipping-detail">{{ packageInformation[0].description }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/route.svg"
                  alt="" /></span
              >ROUTE
            </p>
            <p class="shipping-detail">
              {{ formatAddress(shipper.address) }} -
              {{ formatAddress(consignee.address) }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/distance.svg"
                  alt="" /></span
              >DISTANCE
            </p>
            <p class="shipping-detail">{{ shippingInformation.distance }}</p>
          </div>
          <div
            class="col-12 col-md-6 col-lg-3 right cursor-pointer"
            @click="openRouteInfo"
          >
            <p class="shipping-detail-title"><u>View detailed route info</u></p>
          </div>
        </div>
      </div>

      <hr />

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <p class="font-semibold">Package Details</p>
          </div>
        </div>
        <div class="row" v-for="(packages, index) in packageInformation" :key="index">
          <div class="col-12 mb-3 mt-2">
            <p class="font-semibold">Package {{ index + 1 }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/number-of-packages.svg"
                  alt="" /></span
              >NUMBER OF PACKAGES
            </p>
            <p class="shipping-detail">{{ packages.quantity }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                  alt="" /></span
              >WEIGHT
            </p>
            <p class="shipping-detail">{{ packages.estimatedWeight }}kg</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/dimension.svg"
                  alt="" /></span
              >DIMENSION (LxWxH)
            </p>
            <p class="shipping-detail">
              <span v-if="packages.shipmentType != 'light'"
                >{{ packages.length }}x{{ packages.width }}x{{ packages.height }} cm</span
              >
              <span v-else>N/A</span>
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/special-handling.svg"
                  alt="" /></span
              >SPECIAL HANDLING
            </p>
            <p class="shipping-detail">
              {{
                packages.specialHandling.length >= 1
                  ? packages.specialHandling.join()
                  : "N/A"
              }}
            </p>
          </div>
          <div class="col-12 mt-4 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/declared-value.svg"
                  alt="" /></span
              >DECLARED VALUE
            </p>
            <p class="shipping-detail">₦{{ packages.itemValue }}.00</p>
          </div>
          <div class="col-12 mt-4 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                  alt="" /></span
              >PACKAGE DESCRIPTION
            </p>
            <p class="shipping-detail">{{ packages.description }}</p>
          </div>
        </div>
      </div>

      <hr />

      <div class="container-fluid payment-summary">
        <div class="row">
          <div class="col-12">
            <p class="font-semibold">Payment Summary</p>
          </div>
        </div>

        <div>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <p class="shipping-detail-title">
                <span
                  ><img src="@/assets/images/booking-management/svgs/service.svg" alt=""
                /></span>
                SERVICE
              </p>
              <p class="shipping-detail">
                {{ shippingService.orgName }}
              </p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/net-shipping-cost.svg"
                    alt="" /></span
                >NET SHIPPING COST
              </p>
              <p class="shipping-detail">₦{{ costTypeObject.netPrice }}</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/booking-channel.svg"
                    alt="" /></span
                >HANDLING CHARGES
              </p>
              <p class="shipping-detail">₦{{ costTypeObject.handlingCharges }}</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 right">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/insurance.svg"
                    alt="" /></span
                >INSURANCE
              </p>
              <p class="shipping-detail">₦{{ costTypeObject.insuranceFee }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/booking-channel.svg"
                    alt="" /></span
                >RETURN SHIPPING COST
              </p>
              <p class="shipping-detail">₦0.00</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/stop-diversion-cost.svg"
                    alt="" /></span
                >STOP/DIVERSION COST
              </p>
              <p class="shipping-detail">₦0.00</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/total.svg"
                    alt="" /></span
                >TOTAL
              </p>
              <p class="shipping-detail">₦{{ costTypeObject.totalCost }}</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 right">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/promo-code.svg"
                    alt="" /></span
                >PROMO CODE
              </p>
              <p class="shipping-detail">******</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/total.svg"
                    alt="" /></span
                >DISCOUNT TOTAL
              </p>
              <p class="shipping-detail">₦0.00</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/tax-vat-charges.svg"
                    alt="" /></span
                >Tax/VAT
              </p>
              <p class="shipping-detail">₦{{ costTypeObject.vat }}</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/payment-due.svg"
                    alt="" /></span
                >PAYMENT DUE
              </p>
              <p class="shipping-detail">₦0.00</p>
            </div>
          </div>
        </div>
      </div>
      <div class="my-4">
        <p class="font-normal text-sm">
          This bill excludes duties and other government charges.
        </p>
      </div>
    </div>

    <div class="button-wrapper">
      <p class="mt-4 cursor-pointer underline" @click="$emit('back-one-form')">Back</p>
      <div>
        <div class="flex flex-end gap-4 items-center">
          <div
            class="d-flex hover:bg-gray-100 rounded gap-2 cursor-pointer"
            @click="generateQuote()"
          >
            <span>
              <svg
                v-if="!generatingQuote"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 6H12V0H7.99998V6H4.99998L9.99998 11L15 6ZM19.338 12.532C19.128 12.308 17.727 10.809 17.327 10.418C17.0467 10.1493 16.6733 9.99951 16.285 10H14.528L17.592 12.994H14.048C13.9998 12.9931 13.9523 13.0049 13.9101 13.0283C13.868 13.0516 13.8328 13.0857 13.808 13.127L12.992 15H7.00798L6.19198 13.127C6.16705 13.0858 6.13178 13.0519 6.08968 13.0286C6.04758 13.0052 6.00011 12.9933 5.95198 12.994H2.40798L5.47098 10H3.71498C3.31798 10 2.93898 10.159 2.67298 10.418C2.27298 10.81 0.871981 12.309 0.661981 12.532C0.172981 13.053 -0.0960191 13.468 0.0319809 13.981L0.592981 17.055C0.720981 17.569 1.28398 17.991 1.84498 17.991H18.157C18.718 17.991 19.281 17.569 19.409 17.055L19.97 13.981C20.096 13.468 19.828 13.053 19.338 12.532Z"
                  fill="#383F51"
                />
              </svg>
              <div class="loader" v-else></div>
            </span>
            <span class="text-sm"> Generate Estimate</span>
          </div>
          <button class="button button-long mt-2" @click="$emit('change-form')">
            Make Payment
          </button>
        </div>
      </div>
    </div>

    <multiple-consignee-modal
      :show-modal="isMultipleConsigneeModal"
      @close-modal="isMultipleConsigneeModal = false"
      @change-form="$emit('change-form')"
      @add-new-consignee="$emit('add-new-consignee')"
    />
    <view-detailed-route-modal
      :showModal="viewDetailedRouteModal"
      :booking="bookingComputed"
      @close-modal="viewDetailedRouteModal = false"
    />
  </div>
</template>

<script>
import MultipleConsigneeModal from "./Modals/MultipleConsigneesModal";
import html2pdf from "html2pdf.js";
import ViewDetailedRouteModal from "./Modals/ViewDetailedRouteModal";
export default {
  name: "booking-review",
  components: {
    ViewDetailedRouteModal,
    MultipleConsigneeModal,
  },
  data() {
    return {
      reviewDetails: {},
      isMultipleConsigneeModal: false,
      viewDetailedRouteModal: false,
      generatingQuote: false,
      shippingInformation: "",
      packages: [{}],
    };
  },
  computed: {
    shipper() {
      
      if (this.$store.getters.shipperInformation.location) {
          return this.$store.getters.shipperInformation.location
        } else {
          return this.$store.getters.shipperInformation
        }
    },
    consignee() {
   
        if (this.$store.getters.consigneeInformation.location) {
          return this.$store.getters.consigneeInformation.location;
        } else {this.$store.getters.consigneeInformation.id;
          return this.$store.getters.consigneeInformation;
        }
       
    },
    packageInformation() {
      return this.$store.getters.packageInformation;
    },
    shipInformation() {
      return this.$store.getters.shippingInformation;
    },
    shippingService() {
      return this.$store.getters.shippingService.shippingService;
    },
    costType() {
      return this.$store.getters.costType;
    },
    costTypeObject() {
      if (this.costType == "Standard") {
        return this.$store.getters.costTypes.standardCost;
      } else if (this.costType == "Economy") {
        return this.$store.getters.costTypes.economyCost;
      } else if (this.costType == "Express") {
        return this.$store.getters.costTypes.expressCost;
      } else {
        return this.$store.getters.costTypes;
      }
    },

    paymentInformation() {
      let totalPaymentInformation = this.$store.getters.paymentInformation;
      return totalPaymentInformation;
    },
    packageType() {
      return this.$store.getters.packageType;
    },
    takeOffObject() {
      return this.$store.getters.takeOffTerminals.find(
        (x) => x.id == this.shippingInformation.dropOff
      );
    },
    pickUpObject() {
      return this.$store.getters.pickUpTerminals.find(
        (x) => x.id == this.shippingInformation.pickUp
      );
    },
 packagingTypes() {
      let packagingTypes = [];
      this.reviewDetails.packagees.forEach((selectedPackage) => {
        packagingTypes.push(selectedPackage.packageType);
      });
      return packagingTypes.join();
    },
    bookingComputed() {
      return {
        consigneelocation: this.consignee,
        shipperlocation: this.$store.getters.shipperInformation,
        shippingservice: this.shippingInformation,
        paymentInformation: this.paymentInformation,
        packagees: this.$store.getters.packages,
      };
    },
  },
  async mounted() {
   await  this.getReviewDetails();
    this.$nextTick(() => {
      this.$forceUpdate();
    });
    this.$forceUpdate();
  },
  methods: {
    openRouteInfo() {
      this.viewDetailedRouteModal = true;
    },
    generateQuote() {
      try {
        this.generatingQuote = true;
        var element = document.getElementById("quoteGen");
        html2pdf(element);
        this.generatingQuote = false;
      } catch (e) {
        this.generatingQuote = false;
      }
    },
    async getReviewDetails() {
      try {
        const response = await this.$_getPaymentDetails(this.$store.getters.shippingId);
        this.reviewDetails = response.data.data.shipping;
      } catch (error) {
        this.handleError(error);
      }
    },
    splitSpecialHandlings(specialHandling) {
      let specialHandlingList = specialHandling.join();
      return specialHandlingList;
    },
  },
  watch: {
    shipInformation: {
      handler(val) {
        if (this.shippingInformation.shippingMethod == null) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
        this.shippingInformation = { ...val };
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-form__review {
  background: #ffffff;
  border-radius: 2px;
  padding: 2rem 4rem;
}
.booking-summary__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.5rem 0 4rem 0;
}
p {
  text-transform: capitalize;
}
.booking-form__review {
  padding: 2rem 4rem;
}
.header p {
  color: #383f51;
  font-weight: 600;
}
.row {
  padding-bottom: 1.5rem;
}

.center {
  // padding-left: 4rem;
  // padding-right: 0;
}
.right {
  // padding-left: 5rem;
}
.shipping-detail-title {
  color: #979797;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  span {
    padding-right: 0.5rem;
  }
}
.shipping-detail {
  color: #10233e;
  font-size: 0.9rem;
  font-weight: 500;
  padding-left: 1.5rem;
}
.user-img {
  width: 4rem;
  margin-right: 1rem;
}
.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}
hr {
  margin: 1rem 0;
}
.radio-label span::after {
  background: #bec4d5;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 25px;
  height: 25px;
  overflow: hidden;
}
.loader {
  overflow: hidden;
  margin: auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 3px solid rgba(255, 255, 255, 0.2);
  border-right: 3px solid rgba(255, 255, 255, 0.2);
  border-bottom: 3px solid rgba(255, 255, 255, 0.2);
  border-left: 3px solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
